import { render, staticRenderFns } from "./ToDoAddEditModal.vue?vue&type=template&id=80deb880&scoped=true&"
import script from "./ToDoAddEditModal.vue?vue&type=script&lang=js&"
export * from "./ToDoAddEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ToDoAddEditModal.vue?vue&type=style&index=0&id=80deb880&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80deb880",
  null
  
)

export default component.exports